module.exports = __webpack_public_path__ + "media/pc.c59dcdcd.mp4";